module.exports = __webpack_public_path__ + "logo-centered.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-centered.png
// module id = 859
// module chunks = 0